import React, { useState, useEffect } from "react";
import "../AddCollateral/AddCollateral.css";
import { BsFillHouseAddFill } from "react-icons/bs";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  MenuItem,
  TextField,
} from "@mui/material";
import Button from "@mui/material/Button";
import Sidebar from "../../../Sidebar/Sidebar";
import axios from "axios";
import { ExpandMoreOutlined } from "@mui/icons-material";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useLocation, useNavigate, Link } from "react-router-dom";
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import TaskIcon from "@mui/icons-material/Task";
import { url } from '../../../App'
import Cookies from 'js-cookie';
import { useBorrowerContext } from "../../Borrower/BorrowerDetails/store/borrower-details";
const accordianSX = {
  boxShadow: "0px 0px 4px 1.5px rgba(0, 0, 0, 0.2)",
};
const mainAccordian = {};

const EditCollateral = () => {
  const { borrowerData } = useBorrowerContext();
  console.log(borrowerData)
  const collateralDetails = borrowerData.collateral;
  const [open, setOpen] = useState(false);
  const [data2, setData2] = useState([]);
  const [collateralAddress, setCollateralAddress] = useState("");
  const [collateralState, setCollateralState] = useState("");
  const [collateralCity, setCollateralCity] = useState("");
  const [collateralPincode, setCollateralPincode] = useState("");
  const [collateralSubDist, setCollateralSubDist] = useState("");
  const [collateralLocality, setCollateralLocality] = useState("");
  const [collateraSubDistArr, setCollateralSubDistArr] = useState([]);
  const [collateralLocalityArr, setCollateralLocalityArr] = useState([]);
  const [collateralPropertyNumber, setCollateralPropertyNumber] = useState("");
  const [collateralPropertyOwnerName, setCollateralPropertyOwnerName] = useState("");
  const [collateralId, setCollateralId] = useState("");
  const [collateralPurpose, setCollateralPurpose] = useState("");
  const [hlDetails, sethlDetails] = useState("");
  const [collateral_doc_list, setcollateral_doc_list] = useState(false);
  const [collateral_index2, setcollateral_index2] = useState(false);
  const [collateral_legal_report, setcollateral_legal_report] = useState(false);
  const [collateral_mortgage_deed, setcollateral_mortgage_deed] = useState(false);
  const [collateral_property_doc, setcollateral_property_doc] = useState(false);
  const [collateral_search_report, setcollateral_search_report] = useState(false);
  const [collateral_valuation_report, setcollateral_valuation_report] = useState(false);
  const [collateral_misc_doc, setcollateral_misc_doc] = useState([]);
  const [collateral_property_images, setcollateral_property_images] = useState([]);
  const [negativeArea, setNegativeArea] = useState(false)
  const [collateral_vetting_report, setcollateral_vetting_report] = useState(false);
  const [collateral_bt_soa, setcollateral_bt_soa] = useState(false);
  const [collateral_bt_fc_letter, setcollateral_bt_fc_letter] = useState(false);
  const [collateral_bt_lod, setcollateral_bt_lod] = useState(false);
  const [collateral_bt_release_deed, setcollateral_bt_release_deed] = useState(false);
  const [collateral_bt_noc_ndc, setcollateral_bt_noc_ndc] = useState(false);
  const [collateral_ownership, setcollateral_ownership] = useState("");
  const [collateral_latitude, setcollateral_latitude] = useState("");
  const [collateral_longitude, setcollateral_longitude] = useState("");
  const [collateral_land_purchase_date, setcollateral_land_purchase_date] = useState("");
  const [collateral_sale_deed_value, setcollateral_sale_deed_value] = useState("");
  const [collateral_construction_start_date, setcollateral_construction_start_date] = useState("");
  const [collateral_estimated_cost, setcollateral_estimated_cost] = useState("");
  const [collateral_construction_area, setcollateral_construction_area] = useState("");
  const [collateral_stage_of_construction, setcollateral_stage_of_construction] = useState("");
  const [collateral_stage_of_construction_percent, setcollateral_stage_of_construction_percent] = useState("");
  const [collateral_vetted_cost, setcollateral_vetted_cost] = useState("");
  const [collateral_market_value, setcollateral_market_value] = useState("");
  const [collateral_nature_of_improvement, setcollateral_nature_of_improvement] = useState("");
  const [collateral_improvement_cost, setcollateral_improvement_cost] = useState("");
  const [collateral_improvement_cost_percent, setcollateral_improvement_cost_percent] = useState("");
  const [collateral_nature_of_expansion, setcollateral_nature_of_expansion] = useState("");
  const [collateral_expansion_cost, setcollateral_expansion_cost] = useState("");
  const [collateral_expansion_cost_percent, setcollateral_expansion_cost_percent] = useState("");
  const [collateral_expansion_area, setcollateral_expansion_area] = useState("");
  const [collateral_expansion_reason, setcollateral_expansion_reason] = useState("");
  //new states
  const [collateral_stressed_value_lap, setcollateral_stressed_value_lap] = useState("");
  const [collateral_stressed_value_hl_self_construction, setcollateral_stressed_value_hl_self_construction] = useState("");
  const [collateral_stressed_value_hl_improvement, setcollateral_stressed_value_hl_improvement] = useState("");
  const [collateral_stressed_value_hl_expansion, setcollateral_stressed_value_hl_expansion] = useState("");
  const [collateral_realizable_value_lap, setcollateral_realizable_value_lap] = useState("");
  const [collateral_realizable_value_hl_self_construction, setcollateral_realizable_value_hl_self_construction] = useState("");
  const [collateral_realizable_value_hl_improvement, setcollateral_realizable_value_hl_improvement] = useState("");
  const [collateral_realizable_value_hl_expansion, setcollateral_realizable_value_hl_expansion] = useState("");
  const [collateral_fair_market_value_lap, setcollateral_fair_market_value_lap] = useState("");
  const [collateral_fair_market_value_hl_improvement, setcollateral_fair_market_value_hl_improvement] = useState("");
  const [collateral_fair_market_value_hl_expansion, setcollateral_fair_market_value_hl_expansion] = useState("");
  const [collateral_property_area_ft_lap, setcollateral_property_area_ft_lap] = useState("");
  const [collateral_property_area_ft_hl_self_construction, setcollateral_property_area_ft_hl_self_construction] = useState("");
  const [collateral_property_area_ft_hl_improvement, setcollateral_property_area_ft_hl_improvement] = useState("");
  const [collateral_property_area_ft_hl_expansion, setcollateral_property_area_ft_hl_expansion] = useState("");
  const [collateral_property_area_mtr_lap, setcollateral_property_area_mtr_lap] = useState("");
  const [collateral_property_area_mtr_hl_improvement, setcollateral_property_area_mtr_hl_improvement] = useState("");
  const [collateral_property_area_mtr_hl_expansion, setcollateral_property_area_mtr_hl_expansion] = useState("");
  const [collateral_age_of_property_lap, setcollateral_age_of_property_lap] = useState("");
  const [collateral_age_of_property_hl_improvement, setcollateral_age_of_property_hl_improvement] = useState("");
  const [collateral_age_of_property_hl_expansion, setcollateral_age_of_property_hl_expansion] = useState("");
  const [collateral_build_up_area_sqft_lap, setcollateral_build_up_area_sqft_lap] = useState("");
  const [collateral_build_up_area_sqft_hl_improvement, setcollateral_build_up_area_sqft_hl_improvement] = useState("");
  const [collateral_build_up_area_sqft_hl_expansion, setcollateral_build_up_area_sqft_hl_expansion] = useState("");
  const [collateral_plans_hl_self_construction, setcollateral_plans_hl_self_construction] = useState("");
  const [collateral_plans_hl_improvement, setcollateral_plans_hl_improvement] = useState("");
  const [collateral_plans_hl_expansion, setcollateral_plans_hl_expansion] = useState("");
  const [isAddDoc, setIsAddDoc] = useState(false);

  const navigate = useNavigate();
  const { state } = useLocation();
  const email = Cookies.get('Email');
  const token = Cookies.get('Token');

  useEffect(() => {
    if (email === "rupesh.bishnoi@credin.in") {
      setIsAddDoc(true)
    } else {
      axios
        .post(url + "/user/getsingle", {
          token: token,
          email: email,
          useremail: email
        })
        .then((res) => {
          setIsAddDoc(res.data[0].permission.add_collateral_document);
        })
        .catch((err) => {
          // console.log(err);
          toast.error(err.message);
        })
    }

    axios
      .post(url + "/collateral/getsingle", {
        token: token,
        email: email,
        collateral_id: state.collateral_id
      })
      .then(async (res) => {
        if (state.collateral_pincode) {
          try {
            const { data: response } = await axios.get(`${url}/pincode/${state.collateral_pincode}`, {
              headers: {
                email: email, token: token
              }
            })
            setCollateralSubDistArr(response.subDistricts)
          } catch (err) {
            console.log(err)
          }
        }
        if (state.collateral_subDistrict) {
          try {
            const { data: response } = await axios.get(`${url}/pincode/${state.collateral_pincode}/${state.collateral_subDistrict}`, {
              headers: {
                email: email, token: token
              }
            })
            setCollateralLocalityArr(response.locality)

          } catch (err) {
            console.log(err)
          }
        }

        if (state.collateral_locality) {
          checkNegativeArea(state.collateral_locality)
        }
        // console.log(res.data);
        if (res.data.logout === true) {
          toast.error(res.data.message);
          setTimeout(() => {
            navigate("/");
          }, 3000);
        }
        else {
          setcollateral_doc_list(
            res.data[0].collateral_doc_list
              ? res.data[0].collateral_doc_list.doc_name
              : ""
          );
          setcollateral_index2(
            res.data[0].collateral_index2
              ? res.data[0].collateral_index2.doc_name
              : ""
          );
          setcollateral_legal_report(
            res.data[0].collateral_legal_report
              ? res.data[0].collateral_legal_report.doc_name
              : ""
          );
          setcollateral_mortgage_deed(
            res.data[0].collateral_mortgage_deed
              ? res.data[0].collateral_mortgage_deed.doc_name
              : ""
          );

          setcollateral_property_doc(
            res.data[0].collateral_property_doc
              ? res.data[0].collateral_property_doc.doc_name
              : ""
          );

          setcollateral_search_report(
            res.data[0].collateral_search_report
              ? res.data[0].collateral_search_report.doc_name
              : ""
          );
          setcollateral_valuation_report(
            res.data[0].collateral_valuation_report
              ? res.data[0].collateral_valuation_report.doc_name
              : ""
          );
          setcollateral_vetting_report(
            res.data[0].collateral_vetting_report
              ? res.data[0].collateral_vetting_report.doc_name
              : ""
          );
          setcollateral_bt_soa(
            res.data[0].collateral_bt_soa
              ? res.data[0].collateral_bt_soa.doc_name
              : ""
          );
          setcollateral_bt_fc_letter(
            res.data[0].collateral_bt_fc_letter
              ? res.data[0].collateral_bt_fc_letter.doc_name
              : ""
          );
          setcollateral_bt_lod(
            res.data[0].collateral_bt_lod
              ? res.data[0].collateral_bt_lod.doc_name
              : ""
          );
          setcollateral_bt_release_deed(
            res.data[0].collateral_bt_release_deed
              ? res.data[0].collateral_bt_release_deed.doc_name
              : ""
          );
          setcollateral_bt_noc_ndc(
            res.data[0].collateral_bt_noc_ndc
              ? res.data[0].collateral_bt_noc_ndc.doc_name
              : ""
          );

          let g = [];

          if (res.data[0].collateral_misc_doc) {
            for (let o = 0; o < res.data[0].collateral_misc_doc.length; o++) {
              g.push({
                doc_name: res.data[0].collateral_misc_doc[o].doc_name,
              });
            }
            // console.log(g);
            setcollateral_misc_doc(g);
          }

          let u = [];

          if (res.data[0].collateral_property_images) {
            for (let o = 0; o < res.data[0].collateral_property_images.length; o++) {
              u.push({
                doc_name: res.data[0].collateral_property_images[o].doc_name,
              });
            }
            // console.log(u);
            setcollateral_property_images(u);
          }
        }
      })
      .catch((err) => {
         console.log(err);
      });

    if (!state) {
      navigate("/");
    } else {
      console.log(state,"state");
      setSelectBorrower(state.collateral_borrower_uniqueno);
      setCollateralLoanId(state.collateral_loan_id);
      setSelectCollateralType(state.collateral_type);
      setCollateralAddress(state.collateral_address);
      setCollateralState(state.collateral_state);
      setCollateralCity(state.collateral_city);
      setCollateralLocality(state.collateral_locality);
      setCollateralSubDist(state.collateral_subDistrict);
      setCollateralPincode(state.collateral_pincode);
      setCollateralPropertyNumber(state.collateral_property_number);
      setCollateralPropertyOwnerName(state.collateral_property_owner_name);
      setCollateralId(state.collateral_id);
      setcollateral_ownership(state.collateral_ownership);
      setcollateral_latitude(state.collateral_latitude);
      setcollateral_longitude(state.collateral_longitude);
      setCollateralPurpose(state.collateral_purpose);
      sethlDetails(state.collateral_hl_purpose);
      setcollateral_land_purchase_date(state.collateral_land_purchase_date);
      setcollateral_sale_deed_value(state.collateral_land_purchase_sale_deed_value);
      setcollateral_construction_start_date(state.collateral_construction_start_date);
      setcollateral_estimated_cost(state.collateral_estimated_construction_cost);
      setcollateral_construction_area(state.collateral_total_construction_area);
      setcollateral_stage_of_construction(state.collateral_stage_of_construction);
      setcollateral_stage_of_construction_percent(state.collateral_stage_of_construction_percentage);
      setcollateral_vetted_cost(state.collateral_vetted_cost_of_construction);
      setcollateral_market_value(state.collateral_market_value_of_land);
      setcollateral_nature_of_improvement(state.collateral_nature_of_improvement);
      setcollateral_improvement_cost(state.collateral_improvement_cost);
      setcollateral_improvement_cost_percent(state.collateral_improvement_cost_percentage);
      setcollateral_nature_of_expansion(state.collateral_nature_of_expansion);
      setcollateral_expansion_cost(state.collateral_expansion_cost);
      setcollateral_expansion_cost_percent(state.collateral_expansion_cost_percentage);
      setcollateral_expansion_area(state.collateral_expansion_area);
      setcollateral_expansion_reason(state.collateral_expansion_reason);
      //new fields
      setcollateral_stressed_value_lap(state.collateral_stressed_value_lap);
      setcollateral_stressed_value_hl_self_construction(state.collateral_stressed_value_hl_self_construction);
      setcollateral_stressed_value_hl_improvement(state.collateral_stressed_value_hl_improvement);
      setcollateral_stressed_value_hl_expansion(state.collateral_stressed_value_hl_expansion);
      setcollateral_realizable_value_lap(state.collateral_realizable_value_lap);
      setcollateral_realizable_value_hl_self_construction(state.collateral_realizable_value_hl_self_construction);
      setcollateral_realizable_value_hl_improvement(state.collateral_realizable_value_hl_improvement);
      setcollateral_realizable_value_hl_expansion(state.collateral_realizable_value_hl_expansion);
      setcollateral_fair_market_value_lap(state.collateral_fair_market_value_lap);
      setcollateral_fair_market_value_hl_improvement(state.collateral_fair_market_value_hl_improvement);
      setcollateral_fair_market_value_hl_expansion(state.collateral_fair_market_value_hl_expansion);
      setcollateral_property_area_ft_lap(state.collateral_property_area_ft_lap);
      setcollateral_property_area_ft_hl_self_construction(state.collateral_property_area_ft_hl_self_construction);
      setcollateral_property_area_ft_hl_improvement(state.collateral_property_area_ft_hl_improvement);
      setcollateral_property_area_ft_hl_expansion(state.collateral_property_area_ft_hl_expansion);
      setcollateral_property_area_mtr_lap(state.collateral_property_area_mtr_lap);
      setcollateral_property_area_mtr_hl_improvement(state.collateral_property_area_mtr_hl_improvement);
      setcollateral_property_area_mtr_hl_expansion(state.collateral_property_area_mtr_hl_expansion);
      setcollateral_age_of_property_lap(state.collateral_age_of_property_lap);
      setcollateral_age_of_property_hl_improvement(state.collateral_age_of_property_hl_improvement);
      setcollateral_age_of_property_hl_expansion(state.collateral_age_of_property_hl_expansion);
      setcollateral_build_up_area_sqft_lap(state.collateral_build_up_area_sqft_lap);
      setcollateral_build_up_area_sqft_hl_improvement(state.collateral_build_up_area_sqft_hl_improvement);
      setcollateral_build_up_area_sqft_hl_expansion(state.collateral_build_up_area_sqft_hl_expansion);
      setcollateral_plans_hl_self_construction(state.collateral_plans_hl_self_construction);
      setcollateral_plans_hl_improvement(state.collateral_plans_hl_improvement);
      setcollateral_plans_hl_expansion(state.collateral_plans_hl_expansion);
        axios
          .post(url + "/loan/borrowertoloan", {
            token: token,
            email: email,
            borrower_uniqueno: state.collateral_borrower_uniqueno,
          })
          .then((res) => {
            if (res.data.auth === true) {
              // console.log(res);
              setData2(res.data.message);
            } else {
              // console.log(res);
              setData2([]);
            }
          })
          .catch((err) => {
             console.log(err);
          });
    }
    //eslint-disable-next-line
  }, [token, email, state, navigate]);

  const [isOpen, setIsOpen] = useState(true);
  const openView = (val) => setIsOpen(val);

  const [selectBorrower, setSelectBorrower] = useState("");

  const handleSelectBorrower = (event) => {
    setSelectBorrower(event.target.value);
    setCollateralLoanId("");
    // console.log(event.target.value);
    axios
      .post(url + "/loan/borrowertoloan", {
        token: token,
        email: email,
        borrower_uniqueno: event.target.value,
      })
      .then((res) => {
        if (res.data.auth === true) {
          // console.log(res);
          setData2(res.data.message);
        } else {
          // console.log(res);
          toast.error(res.data.message);
          setData2([]);
        }
      })
      .catch((err) => {
         console.log(err);
      });
  };
  const [collateralLoanId, setCollateralLoanId] = useState("");
  const [selectCollateralType, setSelectCollateralType] = useState("");

  const handleSelectCollateralType = (event) => {
    setSelectCollateralType(event.target.value);
  };

  const handleCollateralPurpose = (event) => {
    setCollateralPurpose(event.target.value);
  };

  const handleHLDetails = (event) => {
    sethlDetails(event.target.value);
  };

  const handleSubmitCollateralDetails = (e) => {
    e.preventDefault();
    setOpen(true);
    axios
      .post(url + "/collateral/update", {
        token: token,
        email: email,
        collateral_borrower_uniqueno: selectBorrower,
        collateral_id: collateralId,
        collateral_loan_id: collateralLoanId,
        collateral_type: selectCollateralType,
        collateral_address: collateralAddress,
        collateral_locality: collateralLocality,
        collateral_subDistrict: collateralSubDist,
        collateral_state: collateralState,
        collateral_city: collateralCity,
        collateral_pincode: collateralPincode,
        collateral_property_number: collateralPropertyNumber,
        collateral_property_owner_name: collateralPropertyOwnerName,
        collateral_ownership: collateral_ownership,
        collateral_latitude: collateral_latitude,
        collateral_longitude: collateral_longitude,
        collateral_purpose:collateralPurpose,
        collateral_hl_purpose:hlDetails,
        collateral_land_purchase_date:collateral_land_purchase_date,
        collateral_land_purchase_sale_deed_value:collateral_sale_deed_value,
        collateral_construction_start_date:collateral_construction_start_date,
        collateral_estimated_construction_cost:collateral_estimated_cost,
        collateral_total_construction_area:collateral_construction_area,
        collateral_stage_of_construction:collateral_stage_of_construction,
        collateral_stage_of_construction_percentage:collateral_stage_of_construction_percent,
        collateral_vetted_cost_of_construction:collateral_vetted_cost,
        collateral_market_value_of_land:collateral_market_value,
        collateral_nature_of_improvement:collateral_nature_of_improvement,
        collateral_improvement_cost:collateral_improvement_cost,
        collateral_improvement_cost_percentage:collateral_improvement_cost_percent,
        collateral_nature_of_expansion:collateral_nature_of_expansion,
        collateral_expansion_cost:collateral_expansion_cost,
        collateral_expansion_cost_percentage:collateral_expansion_cost_percent,
        collateral_expansion_area:collateral_expansion_area,
        collateral_expansion_reason:collateral_expansion_reason,
        //new fields
        collateral_stressed_value_lap: collateral_stressed_value_lap,
        collateral_stressed_value_hl_self_construction: collateral_stressed_value_hl_self_construction,
        collateral_stressed_value_hl_improvement: collateral_stressed_value_hl_improvement,
        collateral_stressed_value_hl_expansion: collateral_stressed_value_hl_expansion,
        collateral_realizable_value_lap: collateral_realizable_value_lap,
        collateral_realizable_value_hl_self_construction: collateral_realizable_value_hl_self_construction,
        collateral_realizable_value_hl_improvement: collateral_realizable_value_hl_improvement,
        collateral_realizable_value_hl_expansion: collateral_realizable_value_hl_expansion,
        collateral_fair_market_value_lap: collateral_fair_market_value_lap,
        collateral_fair_market_value_hl_improvement: collateral_fair_market_value_hl_improvement,
        collateral_fair_market_value_hl_expansion: collateral_fair_market_value_hl_expansion,
        collateral_property_area_ft_lap: collateral_property_area_ft_lap,
        collateral_property_area_ft_hl_self_construction: collateral_property_area_ft_hl_self_construction,
        collateral_property_area_ft_hl_improvement: collateral_property_area_ft_hl_improvement,
        collateral_property_area_ft_hl_expansion: collateral_property_area_ft_hl_expansion,
        collateral_property_area_mtr_lap: collateral_property_area_mtr_lap,
        collateral_property_area_mtr_hl_improvement: collateral_property_area_mtr_hl_improvement,
        collateral_property_area_mtr_hl_expansion: collateral_property_area_mtr_hl_expansion,
        collateral_age_of_property_lap: collateral_age_of_property_lap,
        collateral_age_of_property_hl_improvement: collateral_age_of_property_hl_improvement,
        collateral_age_of_property_hl_expansion: collateral_age_of_property_hl_expansion,
        collateral_build_up_area_sqft_lap: collateral_build_up_area_sqft_lap,
        collateral_build_up_area_sqft_hl_improvement: collateral_build_up_area_sqft_hl_improvement,
        collateral_build_up_area_sqft_hl_expansion: collateral_build_up_area_sqft_hl_expansion,
        collateral_plans_hl_self_construction: collateral_plans_hl_self_construction,
        collateral_plans_hl_improvement: collateral_plans_hl_improvement,
        collateral_plans_hl_expansion: collateral_plans_hl_expansion,
      })
      .then((res) => {
        if (res.data.auth === true) {
          toast.success(res.data.message);
          setTimeout(() => {
            setOpen(false)
            navigate(`/borrower/detail/${collateralDetails.collateral_loan_id || collateralLoanId}`);
          }, 3000);
        } else {
          setOpen(false);
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        toast.error(err.message);
      });
  };

  const uploadLegalReport = (e) => {
    setOpen(true);
    let legalReport = e.target.files;
    if (e.target.files[0] === undefined) {
      setOpen(false);
      return;
    }
    let doc_type = e.target.files[0].name.split(".").pop();
    if (doc_type !== "pdf") {
      setOpen(false);
      toast.error("Please upload Legal Report in Pdf format only");
      return;
    }
    if (doc_type === "jpg") {
      doc_type = "jpeg";
    }
    // console.log(doc_type);
    setcollateral_legal_report(e.target.files[0].name);
    let reader = new FileReader();
    reader.readAsDataURL(legalReport[0]);
    reader.onload = (e) => {
      // console.log(e.target.result);
      let base64_data;
      base64_data = e.target.result.split("base64,").pop();

      // console.log(base64_data);
      axios
        .post(url + "/collateral/adddocument", {
          token: token,
          email: email,
          collateral_id: collateralId,
          doc_name: "collateral_legal_report",
          doc_type: doc_type,
          collateral_borrower_uniqueno: selectBorrower,
          fileName: base64_data,
        })
        .then((res) => {
          // console.log(res);
          if (res.data.auth === true) {
            setOpen(false);
            toast.success(res.data.message);
          } else {
            // console.log(res.data.message);
            setOpen(false);
            toast.error(res.data.message);
          }
        })
        .catch((err) => {
          // console.log(err);
          // toast.dismiss("custom");
          setOpen(false);
          toast.error(err.message);
        });
    };
  };

  const uploadValuationReport = (e) => {
    setOpen(true);
    let valuationReport = e.target.files;
    if (e.target.files[0] === undefined) {
      setOpen(false);
      return;
    }
    let doc_type = e.target.files[0].name.split(".").pop();
    if (doc_type !== "pdf") {
      setOpen(false);
      toast.error("Please upload Valuation Report in Pdf format only");
      return;
    }
    if (doc_type === "jpg") {
      doc_type = "jpeg";
    }
    // console.log(doc_type);
    setcollateral_valuation_report(e.target.files[0].name);
    let reader = new FileReader();
    reader.readAsDataURL(valuationReport[0]);
    reader.onload = (e) => {
      // console.log(e.target.result);
      let base64_data;
      base64_data = e.target.result.split("base64,").pop();
      // console.log(base64_data);
      axios
        .post(url + "/collateral/adddocument", {
          token: token,
          email: email,
          collateral_id: collateralId,
          doc_name: "collateral_valuation_report",
          doc_type: doc_type,
          collateral_borrower_uniqueno: selectBorrower,
          fileName: base64_data,
        })
        .then((res) => {
          // console.log(res);
          if (res.data.auth === true) {
            setOpen(false);
            toast.success(res.data.message);
          } else {
            // console.log(res.data.message);
            setOpen(false);
            toast.error(res.data.message);
          }
        })
        .catch((err) => {
          // console.log(err);
          setOpen(false);
          toast.error(err.message);
        });
    };
  };

  const uploadPropertyDocuments = (e) => {
    setOpen(true);
    let propertyDocuments = e.target.files;
    if (e.target.files[0] === undefined) {
      setOpen(false);
      return;
    }
    let doc_type = e.target.files[0].name.split(".").pop();
    if (doc_type !== "pdf") {
      setOpen(false);
      toast.error("Please upload Sale Deed Copy/ Property Documents in Pdf format only");
      return;
    }
    if (doc_type === "jpg") {
      doc_type = "jpeg";
    }
    // console.log(doc_type);
    setcollateral_property_doc(e.target.files[0].name);
    let reader = new FileReader();
    reader.readAsDataURL(propertyDocuments[0]);
    reader.onload = (e) => {
      // console.log(e.target.result);
      let base64_data;
      base64_data = e.target.result.split("base64,").pop();
      // console.log(base64_data);
      axios
        .post(url + "/collateral/adddocument", {
          token: token,
          email: email,
          collateral_id: collateralId,
          doc_name: "collateral_property_doc",
          doc_type: doc_type,
          collateral_borrower_uniqueno: selectBorrower,
          fileName: base64_data,
        })
        .then((res) => {
          // console.log(res);
          if (res.data.auth === true) {
            setOpen(false);
            toast.success(res.data.message);
          } else {
            // console.log(res.data.message);
            setOpen(false);
            toast.error(res.data.message);
          }
        })
        .catch((err) => {
          // console.log(err);
          setOpen(false);
          toast.error(err.message);
        });
    };
  };

  const uploadMortgageDeed = (e) => {
    setOpen(true);
    let mortgageDeed = e.target.files;
    if (e.target.files[0] === undefined) {
      setOpen(false);
      return;
    }
    let doc_type = e.target.files[0].name.split(".").pop();
    if (doc_type !== "pdf") {
      setOpen(false);
      toast.error("Please upload Mortgage Deed in Pdf format only");
      return;
    }
    if (doc_type === "jpg") {
      doc_type = "jpeg";
    }
    // console.log(doc_type);
    setcollateral_mortgage_deed(e.target.files[0].name);
    let reader = new FileReader();
    reader.readAsDataURL(mortgageDeed[0]);
    reader.onload = (e) => {
      // console.log(e.target.result);
      let base64_data;
      base64_data = e.target.result.split("base64,").pop();

      // console.log(base64_data);
      axios
        .post(url + "/collateral/adddocument", {
          token: token,
          email: email,
          collateral_id: collateralId,
          doc_name: "collateral_mortgage_deed",
          doc_type: doc_type,
          collateral_borrower_uniqueno: selectBorrower,
          fileName: base64_data,
        })
        .then((res) => {
          // console.log(res);
          if (res.data.auth === true) {
            setOpen(false);
            toast.success(res.data.message);
          } else {
            // console.log(res.data.message);
            setOpen(false);
            toast.error(res.data.message);
          }
        })
        .catch((err) => {
          // console.log(err);
          setOpen(false);
          toast.error(err.message);
        });
    };
  };

  const uploadIndex2 = (e) => {
    setOpen(true);
    let index2 = e.target.files;
    if (e.target.files[0] === undefined) {
      setOpen(false);
      return;
    }
    let doc_type = e.target.files[0].name.split(".").pop();
    if (doc_type !== "pdf") {
      setOpen(false);
      toast.error("Please upload Index 2 with Lien Mark in Pdf format only");
      return;
    }
    if (doc_type === "jpg") {
      doc_type = "jpeg";
    }
    // console.log(doc_type);
    setcollateral_index2(e.target.files[0].name);
    let reader = new FileReader();
    reader.readAsDataURL(index2[0]);
    reader.onload = (e) => {
      // console.log(e.target.result);
      let base64_data;
      base64_data = e.target.result.split("base64,").pop();

      // console.log(base64_data);
      axios
        .post(url + "/collateral/adddocument", {
          token: token,
          email: email,
          collateral_id: collateralId,
          doc_name: "collateral_index2",
          doc_type: doc_type,
          collateral_borrower_uniqueno: selectBorrower,
          fileName: base64_data,
        })
        .then((res) => {
          // console.log(res);
          if (res.data.auth === true) {
            setOpen(false);
            toast.success(res.data.message);
          } else {
            // console.log(res.data.message);
            setOpen(false);
            toast.error(res.data.message);
          }
        })
        .catch((err) => {
          // console.log(err);
          setOpen(false);
          toast.error(err.message);
        });
    };
  };

  const uploadDocumentsList = (e) => {
    setOpen(true);
    let documentsList = e.target.files;
    if (e.target.files[0] === undefined) {
      setOpen(false);
      return;
    }
    let doc_type = e.target.files[0].name.split(".").pop();
    if (doc_type !== "pdf") {
      setOpen(false);
      toast.error("Please upload List Of Documents in Pdf format only");
      return;
    }
    if (doc_type === "jpg") {
      doc_type = "jpeg";
    }
    // console.log(doc_type);
    setcollateral_doc_list(e.target.files[0].name);
    let reader = new FileReader();
    reader.readAsDataURL(documentsList[0]);
    reader.onload = (e) => {
      // console.log(e.target.result);
      let base64_data;
      base64_data = e.target.result.split("base64,").pop();

      // console.log(base64_data);
      axios
        .post(url + "/collateral/adddocument", {
          token: token,
          email: email,
          collateral_id: collateralId,
          doc_name: "collateral_doc_list",
          doc_type: doc_type,
          collateral_borrower_uniqueno: selectBorrower,
          fileName: base64_data,
        })
        .then((res) => {
          // console.log(res);
          if (res.data.auth === true) {
            setOpen(false);
            toast.success(res.data.message);
          } else {
            // console.log(res.data.message);
            setOpen(false);
            toast.error(res.data.message);
          }
        })
        .catch((err) => {
          // console.log(err);
          setOpen(false);
          toast.error(err.message);
        });
    };
  };

  const uploadSearchReport = (e) => {
    setOpen(true);
    let searchReport = e.target.files;
    if (e.target.files[0] === undefined) {
      setOpen(false);
      return;
    }
    let doc_type = e.target.files[0].name.split(".").pop();
    if (doc_type !== "pdf") {
      setOpen(false);
      toast.error("Please upload Search Report in Pdf format only");
      return;
    }
    if (doc_type === "jpg") {
      doc_type = "jpeg";
    }
    // console.log(doc_type);
    setcollateral_search_report(e.target.files[0].name);
    let reader = new FileReader();
    reader.readAsDataURL(searchReport[0]);
    reader.onload = (e) => {
      // console.log(e.target.result);
      let base64_data;
      base64_data = e.target.result.split("base64,").pop();
      // console.log(base64_data);
      axios
        .post(url + "/collateral/adddocument", {
          token: token,
          email: email,
          collateral_id: collateralId,
          doc_name: "collateral_search_report",
          doc_type: doc_type,
          collateral_borrower_uniqueno: selectBorrower,
          fileName: base64_data,
        })
        .then((res) => {
          // console.log(res);
          if (res.data.auth === true) {
            setOpen(false);
            toast.success(res.data.message);
          } else {
            // console.log(res.data.message);
            setOpen(false);
            toast.error(res.data.message);
          }
        })
        .catch((err) => {
          // console.log(err);
          setOpen(false);
          toast.error(err.message);
        });
    };
  };

  const uploadMiscDocs = (e) => {
    setOpen(true);
    let miscDocs = e.target.files;
    if (e.target.files[0] === undefined) {
      setOpen(false);
      return;
    }
    let doc_type = e.target.files[0].name.split(".").pop();
    if (doc_type !== "pdf") {
      setOpen(false);
      toast.error("Please upload Miscellaneous Documents in Pdf format only");
      return;
    }
    if (doc_type === "jpg") {
      doc_type = "jpeg";
    }
    // console.log(doc_type);
    var a = [];
    a.push(e.target.files[0].name);
    // console.log(a);
    setcollateral_misc_doc((prevValues) => [...prevValues, a]);
    // console.log(collateral_misc_doc);
    let reader = new FileReader();
    reader.readAsDataURL(miscDocs[0]);
    reader.onload = (e) => {
      // console.log(e.target.result);
      let base64_data;
      base64_data = e.target.result.split("base64,").pop();

      // console.log(base64_data);
      axios
        .post(url + "/collateral/adddocument", {
          token: token,
          email: email,
          collateral_id: collateralId,
          doc_name: "collateral_misc_doc",
          doc_type: doc_type,
          collateral_borrower_uniqueno: selectBorrower,
          fileName: base64_data,
        })
        .then((res) => {
          // console.log(res);
          if (res.data.auth === true) {
            setOpen(false);
            toast.success(res.data.message);
          } else {
            // console.log(res.data.message);
            setOpen(false);
            toast.error(res.data.message);
          }
        })
        .catch((err) => {
          // console.log(err);
          setOpen(false);
          toast.error(err.message);
        });
    };
  };

  const uploadPropertyImages = (e) => {
    setOpen(true);
    let propertyDocs = e.target.files;
    if (e.target.files[0] === undefined) {
      setOpen(false);
      return;
    }
    let doc_type = e.target.files[0].name.split(".").pop();
    if (doc_type !== "jpg" && doc_type !== "png" && doc_type !== "jpeg") {
      setOpen(false);
      toast.error("Please upload Property Images in Jpg or Png format only");
      return;
    }
    if (doc_type === "jpg") {
      doc_type = "jpeg";
    }
    // console.log(doc_type);
    let a = [];
    a.push(e.target.files[0].name);
    setcollateral_property_images((prevValues) => [...prevValues, a]);
    // console.log(collateral_property_images);

    let reader = new FileReader();
    reader.readAsDataURL(propertyDocs[0]);
    reader.onload = (e) => {
      // console.log(e.target.result);
      let base64_data;
      base64_data = e.target.result.split("base64,").pop();
      // console.log(base64_data);
      axios
        .post(url + "/collateral/adddocument", {
          token: token,
          email: email,
          collateral_id: collateralId,
          doc_name: "collateral_property_images",
          doc_type: doc_type,
          collateral_borrower_uniqueno: selectBorrower,
          fileName: base64_data,
        })
        .then((res) => {
          // console.log(res);
          if (res.data.auth === true) {
            setOpen(false);
            toast.success(res.data.message);
          } else {
            // console.log(res.data.message);
            setOpen(false);
            toast.error(res.data.message);
          }
        })
        .catch((err) => {
          // console.log(err);
          setOpen(false);
          toast.error(err.message);
        });
    };
  };

  const uploadVettingReport = (e) => {
    setOpen(true);
    let vettingReport = e.target.files;
    if (e.target.files[0] === undefined) {
      setOpen(false);
      return;
    }
    let doc_type = e.target.files[0].name.split(".").pop();
    if (doc_type !== "pdf") {
      setOpen(false);
      toast.error("Please upload Vetting Report in PDF format only");
      return;
    }
    if (doc_type === "jpg") {
      doc_type = "jpeg";
    }
    // console.log(doc_type);
    setcollateral_vetting_report(e.target.files[0].name);

    let reader = new FileReader();
    reader.readAsDataURL(vettingReport[0]);
    reader.onload = (e) => {
      // console.log(e.target.result);
      let base64_data;
      base64_data = e.target.result.split("base64,").pop();

      // console.log(base64_data);
      axios
        .post(url + "/collateral/adddocument", {
          token: token,
          email: email,
          collateral_id: collateralId,
          doc_name: "collateral_vetting_report",
          doc_type: doc_type,
          collateral_borrower_uniqueno: selectBorrower,
          fileName: base64_data,
        })
        .then((res) => {
          // console.log(res);
          if (res.data.auth === true) {
            setOpen(false);
            toast.success(res.data.message);
          } else {
            // console.log(res.data.message);
            setOpen(false);
            toast.error(res.data.message);
          }
        })
        .catch((err) => {
          // console.log(err);
          setOpen(false);
          toast.error(err.message);
        });
    };
  };

  const uploadSoa = (e) => {
    setOpen(true);
    let soa = e.target.files;
    if (e.target.files[0] === undefined) {
      setOpen(false);
      return;
    }
    let doc_type = e.target.files[0].name.split(".").pop();
    if (doc_type !== "pdf") {
      setOpen(false);
      toast.error("Please upload BT SOA in PDF format only");
      return;
    }
    if (doc_type === "jpg") {
      doc_type = "jpeg";
    }
    // console.log(doc_type);
    setcollateral_bt_soa(e.target.files[0].name);
    let reader = new FileReader();
    reader.readAsDataURL(soa[0]);
    reader.onload = (e) => {
      // console.log(e.target.result);
      let base64_data;
      base64_data = e.target.result.split("base64,").pop();
      // console.log(base64_data);
      axios
        .post(url + "/collateral/adddocument", {
          token: token,
          email: email,
          collateral_id: collateralId,
          doc_name: "collateral_bt_soa",
          doc_type: doc_type,
          collateral_borrower_uniqueno: selectBorrower,
          fileName: base64_data,
        })
        .then((res) => {
          // console.log(res);
          if (res.data.auth === true) {
            setOpen(false);
            toast.success(res.data.message);
          } else {
            // console.log(res.data.message);
            setOpen(false);
            toast.error(res.data.message);
          }
        })
        .catch((err) => {
          // console.log(err);
          setOpen(false);
          toast.error(err.message);
        });
    };
  };

  const uploadFcLetter = (e) => {
    setOpen(true);
    let fcLetter = e.target.files;
    if (e.target.files[0] === undefined) {
      setOpen(false);
      return;
    }
    let doc_type = e.target.files[0].name.split(".").pop();
    if (doc_type !== "pdf") {
      setOpen(false);
      toast.error("Please upload BT FC Letter in PDF format only");
      return;
    }
    if (doc_type === "jpg") {
      doc_type = "jpeg";
    }
    // console.log(doc_type);
    setcollateral_bt_fc_letter(e.target.files[0].name);
    let reader = new FileReader();
    reader.readAsDataURL(fcLetter[0]);
    reader.onload = (e) => {
      // console.log(e.target.result);
      let base64_data;
      base64_data = e.target.result.split("base64,").pop();
      // console.log(base64_data);
      axios
        .post(url + "/collateral/adddocument", {
          token: token,
          email: email,
          collateral_id: collateralId,
          doc_name: "collateral_bt_fc_letter",
          doc_type: doc_type,
          collateral_borrower_uniqueno: selectBorrower,
          fileName: base64_data,
        })
        .then((res) => {
          // console.log(res);
          if (res.data.auth === true) {
            setOpen(false);
            toast.success(res.data.message);
          } else {
            // console.log(res.data.message);
            setOpen(false);
            toast.error(res.data.message);
          }
        })
        .catch((err) => {
          // console.log(err);
          setOpen(false);
          toast.error(err.message);
        });
    };
  };

  const uploadLod = (e) => {
    setOpen(true);
    let lod = e.target.files;
    if (e.target.files[0] === undefined) {
      setOpen(false);
      return;
    }
    let doc_type = e.target.files[0].name.split(".").pop();
    if (doc_type !== "pdf") {
      setOpen(false);
      toast.error("Please upload BT LOD in PDF format only");
      return;
    }
    if (doc_type === "jpg") {
      doc_type = "jpeg";
    }
    // console.log(doc_type);
    setcollateral_bt_lod(e.target.files[0].name);
    let reader = new FileReader();
    reader.readAsDataURL(lod[0]);
    reader.onload = (e) => {
      // console.log(e.target.result);
      let base64_data;
      base64_data = e.target.result.split("base64,").pop();
      // console.log(base64_data);
      axios
        .post(url + "/collateral/adddocument", {
          token: token,
          email: email,
          collateral_id: collateralId,
          doc_name: "collateral_bt_lod",
          doc_type: doc_type,
          collateral_borrower_uniqueno: selectBorrower,
          fileName: base64_data,
        })
        .then((res) => {
          // console.log(res);
          if (res.data.auth === true) {
            setOpen(false);
            toast.success(res.data.message);
          } else {
            // console.log(res.data.message);
            setOpen(false);
            toast.error(res.data.message);
          }
        })
        .catch((err) => {
          // console.log(err);
          setOpen(false);
          toast.error(err.message);
        });
    };
  };

  const uploadReleaseDeed = (e) => {
    setOpen(true);
    let releaseDeed = e.target.files;
    if (e.target.files[0] === undefined) {
      setOpen(false);
      return;
    }
    let doc_type = e.target.files[0].name.split(".").pop();
    if (doc_type !== "pdf") {
      setOpen(false);
      toast.error("Please upload BT Release Deed in PDF format only");
      return;
    }
    if (doc_type === "jpg") {
      doc_type = "jpeg";
    }
    // console.log(doc_type);
    setcollateral_bt_release_deed(e.target.files[0].name);
    let reader = new FileReader();
    reader.readAsDataURL(releaseDeed[0]);
    reader.onload = (e) => {
      // console.log(e.target.result);
      let base64_data;
      base64_data = e.target.result.split("base64,").pop();
      // console.log(base64_data);
      axios
        .post(url + "/collateral/adddocument", {
          token: token,
          email: email,
          collateral_id: collateralId,
          doc_name: "collateral_bt_release_deed",
          doc_type: doc_type,
          collateral_borrower_uniqueno: selectBorrower,
          fileName: base64_data,
        })
        .then((res) => {
          // console.log(res);
          if (res.data.auth === true) {
            setOpen(false);
            toast.success(res.data.message);
          } else {
            // console.log(res.data.message);
            setOpen(false);
            toast.error(res.data.message);
          }
        })
        .catch((err) => {
          // console.log(err);
          // toast.dismiss("custom");
          setOpen(false);
          toast.error(err.message);
        });
    };
  };

  const uploadNoc = (e) => {
    setOpen(true);
    let noc = e.target.files;
    if (e.target.files[0] === undefined) {
      setOpen(false);
      return;
    }
    let doc_type = e.target.files[0].name.split(".").pop();
    if (doc_type !== "pdf") {
      setOpen(false);
      toast.error("Please upload BT NOC/NDC in PDF format only");
      return;
    }
    if (doc_type === "jpg") {
      doc_type = "jpeg";
    }
    // console.log(doc_type);
    setcollateral_bt_noc_ndc(e.target.files[0].name);
    let reader = new FileReader();
    reader.readAsDataURL(noc[0]);
    reader.onload = (e) => {
      // console.log(e.target.result);
      let base64_data;
      base64_data = e.target.result.split("base64,").pop();
      // console.log(base64_data);
      axios
        .post(url + "/collateral/adddocument", {
          token: token,
          email: email,
          collateral_id: collateralId,
          doc_name: "collateral_bt_noc_ndc",
          doc_type: doc_type,
          collateral_borrower_uniqueno: selectBorrower,
          fileName: base64_data,
        })
        .then((res) => {
          // console.log(res);
          if (res.data.auth === true) {
            setOpen(false);
            toast.success(res.data.message);
          } else {
            // console.log(res.data.message);
            setOpen(false);
            toast.error(res.data.message);
          }
        })
        .catch((err) => {
          // console.log(err);
          // toast.dismiss("custom");
          setOpen(false);
          toast.error(err.message);
        });
    };
  };

  const handleChangeSearchPincode = (e) => {
    if (e.target.value.length <= 6) {
      setCollateralPincode(e.target.value);
    }
    if (e.target.value.length === 6) {
      axios
        .get(`${url}/pincode/${e.target.value}`, {
          headers: {
            token: token, email: email
          }
        })
        .then((res) => {
          if (res.data.Status === "Success") {
            toast.success(res.data.Message);
            setCollateralCity(res.data.District);
            setCollateralState(res.data.State);
            setCollateralSubDistArr(res.data.subDistricts)
          } else {
            toast.error(res.data.Message + " for the entered pincode");
            setCollateralCity("");
            setCollateralState("");
            return;
          }
        })
        .catch((err) => {
          // console.log(err);
        });
    }
  }

  const handleSubDistChange = async (e) => {
    setCollateralSubDist(e.target.value);
    try {
      const { data: localityRes } = await axios.get(`${url}/pincode/${collateralPincode}/${e.target.value}`, {
        headers: {
          email: email, token: token
        }
      })
      setCollateralLocalityArr(localityRes.locality)
    } catch (err) {
      console.log(err)
    }
  }

  const checkNegativeArea = async (locality) => {
    setCollateralLocality(locality)
    try {
      const { data: response } = await axios.get(`${url}/pincode/negativearea/${locality}`, {
        headers: {
          token: token, email: email
        }
      })

      if (response.Status === 'Error') {
        return toast.error(response.message)
      }
      setNegativeArea(response.negativeArea)
    } catch (err) {
      console.log(err)
      console.log(err)
    }
  }

  const handlepropertyOwnerName = (e) => {
    var reg = /^([a-zA-Z\s]{0,100})$/;
    // console.log(e.target.value);
    if (reg.test(e.target.value)) {
      setCollateralPropertyOwnerName(e.target.value);
    }
  };

  const handlepropertyNumber = (e) => {
    var reg = /^[0-9\W_]*$/;
    // console.log(e.target.value);
    if (reg.test(e.target.value)) {
      setCollateralPropertyNumber(e.target.value);
    }
  };

  const handleSqftChangeLap = (event) => {
    const sqftValue = event.target.value;
    const sqmtrValue = parseFloat(sqftValue) * 0.092903;
    setcollateral_property_area_ft_lap(sqftValue);
    setcollateral_property_area_mtr_lap(sqmtrValue.toFixed(2));
  };
  const handleSqftChangeHLImprovement = (event) => {
    const sqftValue = event.target.value;
    const sqmtrValue = parseFloat(sqftValue) * 0.092903;
    setcollateral_property_area_ft_hl_improvement(sqftValue);
    setcollateral_property_area_mtr_hl_improvement(sqmtrValue.toFixed(2));
  };

  const handleSqftChangeHLExpansion = (event) => {
    const sqftValue = event.target.value;
    const sqmtrValue = parseFloat(sqftValue) * 0.092903;
    setcollateral_property_area_ft_hl_expansion(sqftValue);
    setcollateral_property_area_mtr_hl_expansion(sqmtrValue.toFixed(2));
  };

  const handleSqmtrChangeLap = (event) => {
    const sqmtrValue = event.target.value;
    const sqftValue = parseFloat(sqmtrValue) / 0.092903;
    setcollateral_property_area_mtr_lap(sqmtrValue);
    setcollateral_property_area_ft_lap(sqftValue.toFixed(2));
  };

  const handleSqmtrChangeHLImprovement = (event) => {
    const sqmtrValue = event.target.value;
    const sqftValue = parseFloat(sqmtrValue) / 0.092903;
    setcollateral_property_area_mtr_hl_improvement(sqmtrValue);
    setcollateral_property_area_ft_hl_improvement(sqftValue.toFixed(2));
  };

  const handleSqmtrChangeHLExpansion = (event) => {
    const sqmtrValue = event.target.value;
    const sqftValue = parseFloat(sqmtrValue) / 0.092903;
    setcollateral_property_area_mtr_hl_expansion(sqmtrValue);
    setcollateral_property_area_ft_hl_expansion(sqftValue.toFixed(2));
  };

  return (
    <>
      <div style={{ height: "20px" }} />
      <Sidebar click={openView} />
      <div style={{ marginLeft: isOpen ? "15%" : "0", transition: "all 0.2s" }}>
        <div className="main-container">
          <div className="content-container">
            <h2 className="main-heading">
              <BsFillHouseAddFill />
              Edit Collateral
            </h2>
            <div className="inner-content-container">
              <Accordion className="accordian-coapp" sx={accordianSX}>
                <AccordionSummary
                  sx={mainAccordian}
                  id="panel1-header"
                  aria-controls="panel1-content"
                  expandIcon={<ExpandMoreOutlined />}
                >
                  <h3 className="accordian-header">Collateral Details</h3>
                </AccordionSummary>
                <form action="" onSubmit={handleSubmitCollateralDetails}>
                  <AccordionDetails>
                    <div className="lms-reg-form">
                      <div className="input-div">
                        <label>Borrower Id*</label>
                        <TextField
                          className="lms-input-field"
                          placeholder="Select Borrower"
                          // select
                          name="select-borrower"
                          variant="outlined"
                          size="small"
                          disabled
                          value={selectBorrower}
                          onChange={handleSelectBorrower}
                        />
                      </div>
                      <div className="input-div">
                        <label>Select Loan Id*</label>
                        <TextField
                          className="lms-input-field"
                          placeholder="Select Loan"
                          select
                          name="select-Loan"
                          variant="outlined"
                          disabled
                          size="small"
                          value={collateralLoanId}
                          onChange={(e) => setCollateralLoanId(e.target.value)}
                        >
                          {data2?.map((data, id) => (
                            <MenuItem key={id} value={data}>
                              {data}
                            </MenuItem>
                          ))}</TextField>
                      </div>
                      <div className="input-div">
                        <label>Collateral Type*</label>
                        <TextField
                          className="lms-input-field"
                          placeholder="Select CollateralType"
                          select
                          required
                          name="select-collateral-type"
                          variant="outlined"
                          size="small"
                          value={selectCollateralType}
                          onChange={handleSelectCollateralType}
                        >
                          <MenuItem value="COMMERCIAL">COMMERCIAL</MenuItem>
                          <MenuItem value="RESIDENCE">RESIDENCE</MenuItem>
                        </TextField>
                      </div>
                      <div className="input-div collateral-address-field">
                        <label>Address*</label>
                        <TextField
                          className="lms-input-field "
                          name="address"
                          value={collateralAddress}
                          required
                          variant="outlined"
                          onChange={(e) => setCollateralAddress(e.target.value)}
                          id="address"
                          placeholder="Collateral Address"
                          size="small"
                        />
                      </div>
                      <div className="input-div">
                        <label htmlFor="sr-pincode">Search PIN Code*</label>
                        <TextField
                          className="lms-input-field"
                          size="small"
                          type="number"
                          placeholder="Search PIN Code"
                          value={collateralPincode}
                          onChange={handleChangeSearchPincode}
                          variant="outlined"
                          id="sr-pincode"
                          name="sr-pincode"
                        />
                      </div>
                      <div className="input-div">
                        <label>State Name*</label>
                        <TextField
                          className="lms-input-field "
                          name="state-name"
                          value={collateralState}
                          variant="outlined"
                          disabled
                          placeholder="State"
                          onChange={(e) => setCollateralState(e.target.value)}
                          id="state-name"
                          size="small"
                        />
                      </div>
                      <div className="input-div">
                        <label>City Name*</label>
                        <TextField
                          className="lms-input-field "
                          name="city-name"
                          variant="outlined"
                          disabled
                          placeholder="City"
                          value={collateralCity}
                          id="city-name"
                          onChange={(e) => setCollateralCity(e.target.value)}
                          size="small"
                        />
                      </div>
                      <div className="input-div">
                        <label htmlFor="city">Sub District*</label>
                        <TextField
                          className="lms-input-field"
                          select
                          size="small"
                          value={collateralSubDist}
                          placeholder="Sub District"
                          variant="outlined"
                          id="city"
                          onChange={handleSubDistChange}
                          name="city"
                        >
                          {collateraSubDistArr?.map(subDistrict => {
                            return <MenuItem value={subDistrict} key={subDistrict}> {subDistrict}</MenuItem>
                          })}
                        </TextField>
                      </div>
                      <div className="input-div">
                        <label htmlFor="city">Locality/Village*</label>
                        <TextField
                          className="lms-input-field"
                          select
                          size="small"
                          error={negativeArea}
                          helperText={negativeArea ? 'Negative Area' : ''}
                          value={collateralLocality}
                          placeholder="Locality/Village"
                          variant="outlined"
                          id="city"
                          onChange={(e) => checkNegativeArea(e.target.value)}
                          name="city"
                        >
                          {collateralLocalityArr?.map(locality => {
                            return <MenuItem key={locality} value={locality}>{locality}</MenuItem>
                          })}
                        </TextField>
                      </div>
                      <div className="input-div">
                        <label>Pin Code*</label>
                        <TextField
                          className="lms-input-field "
                          name="pin-code"
                          value={collateralPincode}
                          disabled
                          type="number"
                          placeholder="Pincode"
                          variant="outlined"
                          onChange={(e) => setCollateralPincode(e.target.value)}
                          id="pin-code"
                          size="small"
                        />
                      </div>
                      <div className="input-div">
                        <label>Ownership</label>
                        <TextField
                          className="lms-input-field "
                          name="AOP-sqmt"
                          placeholder="Ownership"
                          value={collateral_ownership}
                          variant="outlined"
                          onChange={(e) =>
                            setcollateral_ownership(e.target.value)
                          }
                          id="AOP-sqmt"
                          size="small"
                        />
                      </div>
                      <div className="input-div">
                        <label>Latitude </label>
                        <TextField
                          className="lms-input-field "
                          name="AOP-sqmt"
                          placeholder="Latitude"
                          value={collateral_latitude}
                          variant="outlined"
                          onChange={(e) =>
                            setcollateral_latitude(e.target.value)
                          }
                          id="AOP-sqmt"
                          size="small"
                        />
                      </div>
                      <div className="input-div">
                        <label>Longitude</label>
                        <TextField
                          className="lms-input-field "
                          name="AOP-sqmt"
                          placeholder="Longitude"
                          value={collateral_longitude}
                          variant="outlined"
                          onChange={(e) =>
                            setcollateral_longitude(e.target.value)
                          }
                          id="AOP-sqmt"
                          size="small"
                        />
                      </div>
                      <div className="input-div">
                        <label>Property Number*</label>
                        <TextField
                          className="lms-input-field "
                          name="property-number"
                          value={collateralPropertyNumber}
                          variant="outlined"
                          required
                          placeholder="Property Number"
                          onChange={(e) => handlepropertyNumber(e)}
                          id="property-number"
                          size="small"
                        />
                      </div>
                      <div className="input-div">
                        <label>Property Owner's Name*</label>
                        <TextField
                          className="lms-input-field "
                          name="prop-owner-name"
                          value={collateralPropertyOwnerName}
                          variant="outlined"
                          required
                          placeholder="Property Owner Name"
                          onChange={(e) => handlepropertyOwnerName(e)}
                          id="prop-owner-name"
                          size="small"
                        />
                      </div>
                      <div className="input-div collateral-address-field">
                        <label>Collateral Purpose</label>
                        <TextField
                          className="lms-input-field"
                          placeholder="Select Collateral Purpose"
                          select
                          name="select-collateral-type"
                          variant="outlined"
                          size="small"
                          sx={{ width: "33%" }}
                          value={collateralPurpose}
                          onChange={handleCollateralPurpose}
                        >
                          <MenuItem value="LAP">Lap</MenuItem>
                          <MenuItem value="HL">HL</MenuItem>
                        </TextField>
                      </div>
                      {collateralPurpose === "LAP" ? (
                        <>
                          <div className="input-div">
                            <label>Age of Property</label>
                            <TextField
                              className="lms-input-field "
                              name="AOP-sqmt"
                              placeholder="Age of Property"
                              type="number"
                              value={collateral_age_of_property_lap}
                              variant="outlined"
                              onChange={(e) =>
                                setcollateral_age_of_property_lap(e.target.value)
                              }
                              id="AOP-sqmt"
                              size="small"
                            />
                          </div>
                          <div className="input-div">
                            <label>Land Area (in sq. ft)</label>
                            <TextField
                              className="lms-input-field "
                              type="number"
                              name="AOP-sqmt"
                              placeholder="Land Area (in sq. ft)"
                              value={collateral_property_area_ft_lap}
                              variant="outlined"
                              onChange={handleSqftChangeLap}
                              size="small"
                            />
                          </div>
                          <div className="input-div">
                            <label>Land Area (in sq mtrs)</label>
                            <TextField
                              className="lms-input-field"
                              type="number"
                              name="AOP-sqmt"
                              disabled
                              placeholder="Land Area (in sq mtrs)"
                              value={collateral_property_area_mtr_lap}
                              variant="outlined"
                              onChange={handleSqmtrChangeLap}
                              size="small"
                            />
                          </div>
                          <div className="input-div">
                            <label>Build Up Area (sq. ft.)</label>
                            <TextField
                              className="lms-input-field "
                              name="AOP-sqmt"
                              type="number"
                              placeholder="Build Up Area (sq. ft.)"
                              value={collateral_build_up_area_sqft_lap}
                              variant="outlined"
                              onChange={(e) =>
                                setcollateral_build_up_area_sqft_lap(e.target.value)
                              }
                              id="AOP-sqmt"
                              size="small"
                            />
                          </div>
                          <div className="input-div">
                            <label>Stressed value</label>
                            <TextField
                              className="lms-input-field "
                              name="AOP-sqmt"
                              type="number"
                              placeholder="Stressed value"
                              value={collateral_stressed_value_lap}
                              variant="outlined"
                              onChange={(e) =>
                                setcollateral_stressed_value_lap(e.target.value)
                              }
                              id="AOP-sqmt"
                              size="small"
                            />
                          </div>
                          <div className="input-div">
                            <label>Realizable value</label>
                            <TextField
                              className="lms-input-field "
                              name="AOP-sqmt"
                              type="number"
                              placeholder="Realizable value"
                              value={collateral_realizable_value_lap}
                              variant="outlined"
                              onChange={(e) =>
                                setcollateral_realizable_value_lap(e.target.value)
                              }
                              id="AOP-sqmt"
                              size="small"
                            />
                          </div>
                          <div className="input-div">
                            <label>Fair Market Value</label>
                            <TextField
                              className="lms-input-field "
                              name="AOP-sqmt"
                              type="number"
                              placeholder="Fair Market Value"
                              value={collateral_fair_market_value_lap}
                              variant="outlined"
                              onChange={(e) =>
                                setcollateral_fair_market_value_lap(e.target.value)
                              }
                              id="AOP-sqmt"
                              size="small"
                            />
                          </div>
                        </>
                      ) : ""}
                      {collateralPurpose === "HL" ? (
                        <>
                          <div className="input-div collateral-address-field">
                            <label>HL Details</label>
                            <TextField
                              className="lms-input-field"
                              placeholder="Select HL Details"
                              select
                              name="select-collateral-type"
                              variant="outlined"
                              size="small"
                              sx={{ width: "33%" }}
                              value={hlDetails}
                              onChange={handleHLDetails}
                            >
                              <MenuItem value="self_construction">Self-Construction</MenuItem>
                              <MenuItem value="improvement">Improvement</MenuItem>
                              <MenuItem value="expansion">Expansion</MenuItem>
                            </TextField>
                          </div>
                          {hlDetails === "self_construction" ? (
                            <>
                              <div className="input-div">
                                <label>Land Purchase Date</label>
                                <TextField
                                  className="lms-input-field "
                                  type="date"
                                  name="AOP-sqmt"
                                  placeholder="Land Purchase Date"
                                  value={collateral_land_purchase_date ? collateral_land_purchase_date.slice(0, 10) : ""}
                                  variant="outlined"
                                  onChange={(e) =>
                                    setcollateral_land_purchase_date(e.target.value)
                                  }
                                  id="AOP-sqmt"
                                  size="small"
                                  inputProps={{
                                    max: new Date().toISOString().split("T")[0],
                                  }}
                                />
                              </div>
                              <div className="input-div">
                                <label>Land Purchase/Sale Deed Value</label>
                                <TextField
                                  className="lms-input-field "
                                  name="AOP-sqmt"
                                  type="number"
                                  placeholder="Land Purchase/Sale Deed Value"
                                  value={collateral_sale_deed_value}
                                  variant="outlined"
                                  onChange={(e) =>
                                    setcollateral_sale_deed_value(e.target.value)
                                  }
                                  id="AOP-sqmt"
                                  size="small"
                                />
                              </div>
                              <div className="input-div">
                                <label>Construction Start Date,if Already Started</label>
                                <TextField
                                  className="lms-input-field "
                                  name="AOP-sqmt"
                                  type="date"
                                  placeholder="Construction Start Date,if Already Started"
                                  value={collateral_construction_start_date ? collateral_construction_start_date.slice(0, 10) : ""}
                                  variant="outlined"
                                  onChange={(e) =>
                                    setcollateral_construction_start_date(e.target.value)
                                  }
                                  id="AOP-sqmt"
                                  size="small"
                                  inputProps={{
                                    max: new Date().toISOString().split("T")[0],
                                  }}
                                />
                              </div>
                              <div className="input-div">
                                <label>Plan/Sanction Approval Status</label>
                                <TextField
                                  className="lms-input-field "
                                  name="AOP-sqmt"
                                  placeholder="Plan/Sanction Approval Status"
                                  value={collateral_plans_hl_self_construction}
                                  variant="outlined"
                                  onChange={(e) =>
                                    setcollateral_plans_hl_self_construction(e.target.value)
                                  }
                                  id="AOP-sqmt"
                                  size="small"
                                />
                              </div>
                              <div className="input-div">
                                <label>Estimated Cost of Construction Per Sqr Ft</label>
                                <TextField
                                  className="lms-input-field "
                                  name="AOP-sqmt"
                                  type="number"
                                  placeholder="Estimated Cost of Construction Per Sqr Ft"
                                  value={collateral_estimated_cost}
                                  variant="outlined"
                                  onChange={(e) =>
                                    setcollateral_estimated_cost(e.target.value)
                                  }
                                  id="AOP-sqmt"
                                  size="small"
                                />
                              </div>
                              <div className="input-div">
                                <label>Total Construction Area</label>
                                <TextField
                                  className="lms-input-field "
                                  name="AOP-sqmt"
                                  type="number"
                                  placeholder="Total Construction Area"
                                  value={collateral_construction_area}
                                  variant="outlined"
                                  onChange={(e) =>
                                    setcollateral_construction_area(e.target.value)
                                  }
                                  id="AOP-sqmt"
                                  size="small"
                                />
                              </div>
                              <div className="input-div">
                                <label>Stage of Construction</label>
                                <TextField
                                  className="lms-input-field "
                                  name="AOP-sqmt"
                                  placeholder="Stage of Construction"
                                  value={collateral_stage_of_construction}
                                  variant="outlined"
                                  onChange={(e) =>
                                    setcollateral_stage_of_construction(e.target.value)
                                  }
                                  id="AOP-sqmt"
                                  size="small"
                                />
                              </div>
                              <div className="input-div">
                                <label>Stage of Construction %</label>
                                <TextField
                                  className="lms-input-field "
                                  name="AOP-sqmt"
                                  placeholder="Stage of Construction%"
                                  value={collateral_stage_of_construction_percent}
                                  variant="outlined"
                                  onChange={(e) =>
                                    setcollateral_stage_of_construction_percent(e.target.value)
                                  }
                                  id="AOP-sqmt"
                                  size="small"
                                />
                              </div>
                              <div className="input-div">
                                <label>Land Area (inSqrFt)</label>
                                <TextField
                                  className="lms-input-field "
                                  name="AOP-sqmt"
                                  type="number"
                                  placeholder="Land Area (inSqrFt)"
                                  value={collateral_property_area_ft_hl_self_construction}
                                  variant="outlined"
                                  onChange={(e) =>
                                    setcollateral_property_area_ft_hl_self_construction(e.target.value)
                                  }
                                  id="AOP-sqmt"
                                  size="small"
                                />
                              </div>
                              <div className="input-div">
                                <label>Vetted Cost of Construction</label>
                                <TextField
                                  className="lms-input-field "
                                  name="AOP-sqmt"
                                  type="number"
                                  placeholder="Vetted Cost of Construction"
                                  value={collateral_vetted_cost}
                                  variant="outlined"
                                  onChange={(e) =>
                                    setcollateral_vetted_cost(e.target.value)
                                  }
                                  id="AOP-sqmt"
                                  size="small"
                                />
                              </div>
                              <div className="input-div">
                                <label>Market Value of Land</label>
                                <TextField
                                  className="lms-input-field "
                                  name="AOP-sqmt"
                                  placeholder="Market Value of Land"
                                  type="number"
                                  value={collateral_market_value}
                                  variant="outlined"
                                  onChange={(e) =>
                                    setcollateral_market_value(e.target.value)
                                  }
                                  id="AOP-sqmt"
                                  size="small"
                                />
                              </div>
                              <div className="input-div">
                                <label>Stressed value</label>
                                <TextField
                                  className="lms-input-field "
                                  name="AOP-sqmt"
                                  type="number"
                                  placeholder="Stressed value"
                                  value={collateral_stressed_value_hl_self_construction}
                                  variant="outlined"
                                  onChange={(e) =>
                                    setcollateral_stressed_value_hl_self_construction(e.target.value)
                                  }
                                  id="AOP-sqmt"
                                  size="small"
                                />
                              </div>
                              <div className="input-div">
                                <label>Realizable value</label>
                                <TextField
                                  className="lms-input-field "
                                  name="AOP-sqmt"
                                  type="number"
                                  placeholder="Realizable value"
                                  value={collateral_realizable_value_hl_self_construction}
                                  variant="outlined"
                                  onChange={(e) =>
                                    setcollateral_realizable_value_hl_self_construction(e.target.value)
                                  }
                                  id="AOP-sqmt"
                                  size="small"
                                />
                              </div>
                            </>
                          ) : ""}
                          {hlDetails === "improvement" ? (
                            <>
                              <div className="input-div">
                                <label>Nature of Improvement</label>
                                <TextField
                                  className="lms-input-field "
                                  name="AOP-sqmt"
                                  placeholder="Nature of Improvement"
                                  value={collateral_nature_of_improvement}
                                  variant="outlined"
                                  onChange={(e) =>
                                    setcollateral_nature_of_improvement(e.target.value)
                                  }
                                  id="AOP-sqmt"
                                  size="small"
                                />
                              </div>
                              <div className="input-div">
                                <label>Improvement Cost</label>
                                <TextField
                                  className="lms-input-field "
                                  name="AOP-sqmt"
                                  type="number"
                                  placeholder="Improvement Cost"
                                  value={collateral_improvement_cost}
                                  variant="outlined"
                                  onChange={(e) =>
                                    setcollateral_improvement_cost(e.target.value)
                                  }
                                  id="AOP-sqmt"
                                  size="small"
                                />
                              </div>
                              <div className="input-div">
                                <label>Improvement Cost % (Cost to Property Value)</label>
                                <TextField
                                  className="lms-input-field "
                                  name="AOP-sqmt"
                                  type="number"
                                  placeholder="Improvement Cost % (Cost to Property Value)"
                                  value={collateral_improvement_cost_percent}
                                  variant="outlined"
                                  onChange={(e) =>
                                    setcollateral_improvement_cost_percent(e.target.value)
                                  }
                                  id="AOP-sqmt"
                                  size="small"
                                />
                              </div>
                              <div className="input-div">
                                <label>Plan/Sanction Approval Status</label>
                                <TextField
                                  className="lms-input-field "
                                  name="AOP-sqmt"
                                  placeholder="Plan/Sanction Approval Status"
                                  value={collateral_plans_hl_improvement}
                                  variant="outlined"
                                  onChange={(e) =>
                                    setcollateral_plans_hl_improvement(e.target.value)
                                  }
                                  id="AOP-sqmt"
                                  size="small"
                                />
                              </div>
                              <div className="input-div">
                                <label>Age of Property</label>
                                <TextField
                                  className="lms-input-field "
                                  name="AOP-sqmt"
                                  type="number"
                                  placeholder="Age of Property"
                                  value={collateral_age_of_property_hl_improvement}
                                  variant="outlined"
                                  onChange={(e) =>
                                    setcollateral_age_of_property_hl_improvement(e.target.value)
                                  }
                                  id="AOP-sqmt"
                                  size="small"
                                />
                              </div>
                              <div className="input-div">
                                <label>Land Area (in sq. ft)</label>
                                <TextField
                                  className="lms-input-field "
                                  name="AOP-sqmt"
                                  type="number"
                                  placeholder="Land Area (in sq. ft)"
                                  value={collateral_property_area_ft_hl_improvement}
                                  variant="outlined"
                                  onChange={handleSqftChangeHLImprovement}
                                  id="AOP-sqmt"
                                  size="small"
                                />
                              </div>
                              <div className="input-div">
                                <label>Land Area (in sq mtrs)</label>
                                <TextField
                                  className="lms-input-field "
                                  name="AOP-sqmt"
                                  disabled
                                  placeholder="Land Area (in sq mtrs)"
                                  value={collateral_property_area_mtr_hl_improvement}
                                  variant="outlined"
                                  onChange={handleSqmtrChangeHLImprovement}
                                  id="AOP-sqmt"
                                  size="small"
                                />
                              </div>
                              <div className="input-div">
                                <label>Build Up Area (sq. ft.)</label>
                                <TextField
                                  className="lms-input-field "
                                  name="AOP-sqmt"
                                  type="number"
                                  placeholder="Build Up Area (sq. ft.)"
                                  value={collateral_build_up_area_sqft_hl_improvement}
                                  variant="outlined"
                                  onChange={(e) =>
                                    setcollateral_build_up_area_sqft_hl_improvement(e.target.value)
                                  }
                                  id="AOP-sqmt"
                                  size="small"
                                />
                              </div>
                              <div className="input-div">
                                <label>Stressed value</label>
                                <TextField
                                  className="lms-input-field "
                                  name="AOP-sqmt"
                                  type="number"
                                  placeholder="Stressed value"
                                  value={collateral_stressed_value_hl_improvement}
                                  variant="outlined"
                                  onChange={(e) =>
                                    setcollateral_stressed_value_hl_improvement(e.target.value)
                                  }
                                  id="AOP-sqmt"
                                  size="small"
                                />
                              </div>
                              <div className="input-div">
                                <label>Realizable value</label>
                                <TextField
                                  className="lms-input-field "
                                  name="AOP-sqmt"
                                  type="number"
                                  placeholder="Realizable value"
                                  value={collateral_realizable_value_hl_improvement}
                                  variant="outlined"
                                  onChange={(e) =>
                                    setcollateral_realizable_value_hl_improvement(e.target.value)
                                  }
                                  id="AOP-sqmt"
                                  size="small"
                                />
                              </div>
                              <div className="input-div">
                                <label>Fair Market Value</label>
                                <TextField
                                  className="lms-input-field "
                                  name="AOP-sqmt"
                                  type="number"
                                  placeholder="Fair Market Value"
                                  value={collateral_fair_market_value_hl_improvement}
                                  variant="outlined"
                                  onChange={(e) =>
                                    setcollateral_fair_market_value_hl_improvement(e.target.value)
                                  }
                                  id="AOP-sqmt"
                                  size="small"
                                />
                              </div>
                            </>
                          ) : ""}
                          {hlDetails === "expansion" ? (
                            <>
                              <div className="input-div">
                                <label>Nature of Expansion</label>
                                <TextField
                                  className="lms-input-field "
                                  name="AOP-sqmt"
                                  placeholder="Nature of Expansion"
                                  value={collateral_nature_of_expansion}
                                  variant="outlined"
                                  onChange={(e) =>
                                    setcollateral_nature_of_expansion(e.target.value)
                                  }
                                  id="AOP-sqmt"
                                  size="small"
                                />
                              </div>
                              <div className="input-div">
                                <label>Expansion Cost</label>
                                <TextField
                                  className="lms-input-field "
                                  name="AOP-sqmt"
                                  type="number"
                                  placeholder="Expansion Cost"
                                  value={collateral_expansion_cost}
                                  variant="outlined"
                                  onChange={(e) =>
                                    setcollateral_expansion_cost(e.target.value)
                                  }
                                  id="AOP-sqmt"
                                  size="small"
                                />
                              </div>
                              <div className="input-div">
                                <label>Expansion Cost % (Cost to Property Value)</label>
                                <TextField
                                  className="lms-input-field "
                                  name="AOP-sqmt"
                                  type="number"
                                  placeholder="Expansion Cost % (Cost to Property Value)"
                                  value={collateral_expansion_cost_percent}
                                  variant="outlined"
                                  onChange={(e) =>
                                    setcollateral_expansion_cost_percent(e.target.value)
                                  }
                                  id="AOP-sqmt"
                                  size="small"
                                />
                              </div>
                              <div className="input-div">
                                <label>Expansion Area</label>
                                <TextField
                                  className="lms-input-field "
                                  name="AOP-sqmt"
                                  placeholder="Expansion Area"
                                  type="number"
                                  value={collateral_expansion_area}
                                  variant="outlined"
                                  onChange={(e) =>
                                    setcollateral_expansion_area(e.target.value)
                                  }
                                  id="AOP-sqmt"
                                  size="small"
                                />
                              </div>
                              <div className="input-div">
                                <label>Expansion Reason</label>
                                <TextField
                                  className="lms-input-field "
                                  name="AOP-sqmt"
                                  placeholder="Expansion Reason"
                                  value={collateral_expansion_reason}
                                  variant="outlined"
                                  onChange={(e) =>
                                    setcollateral_expansion_reason(e.target.value)
                                  }
                                  id="AOP-sqmt"
                                  size="small"
                                />
                              </div>
                              <div className="input-div">
                                <label>Plan/Sanction Approval Status</label>
                                <TextField
                                  className="lms-input-field "
                                  name="AOP-sqmt"
                                  placeholder="Plan/Sanction Approval Status"
                                  value={collateral_plans_hl_expansion}
                                  variant="outlined"
                                  onChange={(e) =>
                                    setcollateral_plans_hl_expansion(e.target.value)
                                  }
                                  id="AOP-sqmt"
                                  size="small"
                                />
                              </div>
                              <div className="input-div">
                                <label>Age of Property</label>
                                <TextField
                                  className="lms-input-field "
                                  name="AOP-sqmt"
                                  placeholder="Age of Property"
                                  type="number"
                                  value={collateral_age_of_property_hl_expansion}
                                  variant="outlined"
                                  onChange={(e) =>
                                    setcollateral_age_of_property_hl_expansion(e.target.value)
                                  }
                                  id="AOP-sqmt"
                                  size="small"
                                />
                              </div>
                              <div className="input-div">
                                <label>Land Area (in sq. ft)</label>
                                <TextField
                                  className="lms-input-field "
                                  name="AOP-sqmt"
                                  type="number"
                                  placeholder="Land Area (in sq. ft)"
                                  value={collateral_property_area_ft_hl_expansion}
                                  variant="outlined"
                                  onChange={handleSqftChangeHLExpansion}
                                  id="AOP-sqmt"
                                  size="small"
                                />
                              </div>
                              <div className="input-div">
                                <label>Land Area (in sq mtrs)</label>
                                <TextField
                                  className="lms-input-field "
                                  name="AOP-sqmt"
                                  disabled
                                  placeholder="Land Area (in sq mtrs)"
                                  value={collateral_property_area_mtr_hl_expansion}
                                  variant="outlined"
                                  onChange={handleSqmtrChangeHLExpansion}
                                  id="AOP-sqmt"
                                  size="small"
                                />
                              </div>
                              <div className="input-div">
                                <label>Build Up Area (sq.ft.)</label>
                                <TextField
                                  className="lms-input-field "
                                  name="AOP-sqmt"
                                  type="number"
                                  placeholder="Build Up Area (sq.ft.)"
                                  value={collateral_build_up_area_sqft_hl_expansion}
                                  variant="outlined"
                                  onChange={(e) =>
                                    setcollateral_build_up_area_sqft_hl_expansion(e.target.value)
                                  }
                                  id="AOP-sqmt"
                                  size="small"
                                />
                              </div>
                              <div className="input-div">
                                <label>Stressed value</label>
                                <TextField
                                  className="lms-input-field "
                                  name="AOP-sqmt"
                                  type="number"
                                  placeholder="Stressed value"
                                  value={collateral_stressed_value_hl_expansion}
                                  variant="outlined"
                                  onChange={(e) =>
                                    setcollateral_stressed_value_hl_expansion(e.target.value)
                                  }
                                  id="AOP-sqmt"
                                  size="small"
                                />
                              </div>
                              <div className="input-div">
                                <label>Realizable value</label>
                                <TextField
                                  className="lms-input-field "
                                  name="AOP-sqmt"
                                  type="number"
                                  placeholder="Realizable value"
                                  value={collateral_realizable_value_hl_expansion}
                                  variant="outlined"
                                  onChange={(e) =>
                                    setcollateral_realizable_value_hl_expansion(e.target.value)
                                  }
                                  id="AOP-sqmt"
                                  size="small"
                                />
                              </div>
                              <div className="input-div">
                                <label>Fair Market Value</label>
                                <TextField
                                  className="lms-input-field "
                                  name="AOP-sqmt"
                                  type="number"
                                  placeholder="Fair Market Value"
                                  value={collateral_fair_market_value_hl_expansion}
                                  variant="outlined"
                                  onChange={(e) =>
                                    setcollateral_fair_market_value_hl_expansion(e.target.value)
                                  }
                                  id="AOP-sqmt"
                                  size="small"
                                />
                              </div>
                            </>
                          ) : ""}
                        </>
                      ) : ""}
                    </div>
                  </AccordionDetails>
                  <div className="btns-add-borrower">
                    <Button
                      variant="contained"
                      color="success"
                      type="submit"
                      style={{ marginRight: "1rem" }}
                    >
                      Update
                    </Button>
                  </div>
                </form>
              </Accordion>
              {isAddDoc && (
                <Accordion className="accordian-coapp" sx={accordianSX}>
                  <AccordionSummary
                    sx={mainAccordian}
                    id="panel1-header"
                    aria-controls="panel1-content"
                    expandIcon={<ExpandMoreOutlined />}
                  >
                    <h3 className="accordian-header">Collateral Documents</h3>
                  </AccordionSummary>
                  <AccordionDetails>
                    <p style={{ color: "red", fontWeight: "bold" }}>
                      Important: Size of documents must not exceed 1 MB*
                    </p>
                    <br />

                    <div className="docs-add-borrower">
                      <div className="input-item-doc">
                        <label style={{ fontWeight: "bold" }}>Legal Report</label>
                        <input
                          type="file"
                          name="legal-report"
                          onChange={(e) => uploadLegalReport(e)}
                        />
                        {collateral_legal_report ? (
                          <TaskIcon sx={{ color: "green", fontSize: "2rem" }} />
                        ) : (
                          ""
                        )}
                      </div>
                      <div className="input-item-doc">
                        <label style={{ fontWeight: "bold" }}>
                          Valuation Report
                        </label>
                        <input
                          type="file"
                          name="valuation-report"
                          onChange={(e) => uploadValuationReport(e)}
                        />
                        {collateral_valuation_report ? (
                          <TaskIcon sx={{ color: "green", fontSize: "2rem" }} />
                        ) : (
                          ""
                        )}
                      </div>
                      <div className="input-item-doc">
                        <label style={{ fontWeight: "bold" }}>
                          Sale Deed Copy/ Property Documents
                        </label>
                        <input
                          type="file"
                          name="property-documents"
                          onChange={(e) => uploadPropertyDocuments(e)}
                        />
                        {collateral_property_doc ? (
                          <TaskIcon sx={{ color: "green", fontSize: "2rem" }} />
                        ) : (
                          ""
                        )}
                      </div>
                      <div className="input-item-doc">
                        <label style={{ fontWeight: "bold" }}>
                          Mortgage Deed
                        </label>
                        <input
                          type="file"
                          name="mortgage-deed"
                          onChange={(e) => uploadMortgageDeed(e)}
                        />
                        {collateral_mortgage_deed ? (
                          <TaskIcon sx={{ color: "green", fontSize: "2rem" }} />
                        ) : (
                          ""
                        )}
                      </div>
                      <div className="input-item-doc">
                        <label style={{ fontWeight: "bold" }}>
                          Index 2 with Lien Mark
                        </label>
                        <input
                          type="file"
                          name="index-2"
                          onChange={(e) => uploadIndex2(e)}
                        />
                        {collateral_index2 ? (
                          <TaskIcon sx={{ color: "green", fontSize: "2rem" }} />
                        ) : (
                          ""
                        )}
                      </div>
                      <div className="input-item-doc">
                        <label style={{ fontWeight: "bold" }}>
                          List Of Documents
                        </label>
                        <input
                          type="file"
                          name="documents-list"
                          onChange={(e) => uploadDocumentsList(e)}
                        />
                        {collateral_doc_list ? (
                          <TaskIcon sx={{ color: "green", fontSize: "2rem" }} />
                        ) : (
                          ""
                        )}
                      </div>
                      <div className="input-item-doc">
                        <label style={{ fontWeight: "bold" }}>
                          Search Report
                        </label>
                        <input
                          type="file"
                          name="search-document"
                          onChange={(e) => uploadSearchReport(e)}
                        />
                        {collateral_search_report ? (
                          <TaskIcon sx={{ color: "green", fontSize: "2rem" }} />
                        ) : (
                          ""
                        )}
                      </div>
                      <div className="input-item-doc">
                        <label style={{ fontWeight: "bold" }}>
                          Property Images
                        </label>
                        <input
                          type="file"
                          name="search-document"
                          onChange={(e) => uploadPropertyImages(e)}
                        />
                        {collateral_property_images.length > 0 ? (
                          <div>
                            <TaskIcon sx={{ color: "green", fontSize: "2rem" }} />
                            ({collateral_property_images.length})
                          </div>

                        ) : (
                          ""
                        )}
                      </div>
                      <div className="input-item-doc">
                        <label style={{ fontWeight: "bold" }}>
                          Miscellaneous Documents
                        </label>
                        <input
                          type="file"
                          name="misc-docs"
                          onChange={(e) => uploadMiscDocs(e)}
                        />
                        {collateral_misc_doc.length > 0 ? (
                          <div>
                            <TaskIcon sx={{ color: "green", fontSize: "2rem" }} />
                            ({collateral_misc_doc.length})
                          </div>
                        ) : (
                          ""
                        )}
                      </div>

                      <div className="input-item-doc">
                        <label style={{ fontWeight: "bold" }}>
                          Vetting Report
                        </label>
                        <input
                          type="file"
                          name="search-document"
                          onChange={(e) => uploadVettingReport(e)}
                        />
                        {collateral_vetting_report ? (
                          <TaskIcon sx={{ color: "green", fontSize: "2rem" }} />
                        ) : (
                          ""
                        )}
                      </div>
                      <div className="input-item-doc">
                        <label style={{ fontWeight: "bold" }}>
                          BT SOA
                        </label>
                        <input
                          type="file"
                          name="search-document"
                          onChange={(e) => uploadSoa(e)}
                        />
                        {collateral_bt_soa ? (
                          <TaskIcon sx={{ color: "green", fontSize: "2rem" }} />
                        ) : (
                          ""
                        )}
                      </div>
                      <div className="input-item-doc">
                        <label style={{ fontWeight: "bold" }}>
                          BT FC Letter
                        </label>
                        <input
                          type="file"
                          name="search-document"
                          onChange={(e) => uploadFcLetter(e)}
                        />
                        {collateral_bt_fc_letter ? (
                          <TaskIcon sx={{ color: "green", fontSize: "2rem" }} />
                        ) : (
                          ""
                        )}

                      </div>
                      <div className="input-item-doc">
                        <label style={{ fontWeight: "bold" }}>
                          BT LOD
                        </label>
                        <input
                          type="file"
                          name="search-document"
                          onChange={(e) => uploadLod(e)}
                        />
                        {collateral_bt_lod ? (
                          <TaskIcon sx={{ color: "green", fontSize: "2rem" }} />
                        ) : (
                          ""
                        )}
                      </div>
                      <div className="input-item-doc">
                        <label style={{ fontWeight: "bold" }}>
                          BT Release Deed
                        </label>
                        <input
                          type="file"
                          name="search-document"
                          onChange={(e) => uploadReleaseDeed(e)}
                        />
                        {collateral_bt_release_deed ? (
                          <TaskIcon sx={{ color: "green", fontSize: "2rem" }} />
                        ) : (
                          ""
                        )}

                      </div>
                      <div className="input-item-doc">
                        <label style={{ fontWeight: "bold" }}>
                          BT NOC/NDC
                        </label>
                        <input
                          type="file"
                          name="search-document"
                          onChange={(e) => uploadNoc(e)}
                        />
                        {collateral_bt_noc_ndc ? (
                          <TaskIcon sx={{ color: "green", fontSize: "2rem" }} />
                        ) : (
                          ""
                        )}

                      </div>
                    </div>
                  </AccordionDetails>
                </Accordion>
              )}
              <div className="form-btns">
                <Link to="/collateral/view">
                  <Button variant="contained">View Collaterals</Button>
                </Link>
              </div>
            </div>
          </div>
        </div>
        <ToastContainer />
        <Backdrop
          sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={open}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      </div>
    </>
  );
};

export default EditCollateral;
